// PHASE 8: Can you see yourself as a fluent speaker?
import SingleChoiceQuestionPage from '@app-studio-web/ui/pages/SingleChoiceQuestionPage'
import { AnswerType } from '@app-studio-web/ui/types'

const answers: AnswerType[] = [
  {
    emoji: '✨',
    title: 'pages.onboarding.identityShift.answer1',
    subtitle: 'pages.onboarding.identityShift.answer1Subtitle',
  },
  {
    emoji: '🌅',
    title: 'pages.onboarding.identityShift.answer2',
    subtitle: 'pages.onboarding.identityShift.answer2Subtitle',
  },
  {
    emoji: '🤞',
    title: 'pages.onboarding.identityShift.answer3',
    subtitle: 'pages.onboarding.identityShift.answer3Subtitle',
  },
  {
    emoji: '🌱',
    title: 'pages.onboarding.identityShift.answer4',
    subtitle: 'pages.onboarding.identityShift.answer4Subtitle',
  },
]

export default function IdentityShiftPage() {
  return (
    <SingleChoiceQuestionPage
      answers={answers}
      title="pages.onboarding.identityShift.title"
      subtitle="pages.onboarding.identityShift.subtitle"
    />
  )
}
